"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Package Management",
  subtitle: "Manage subscription packages",
  listEndpoint: "package/package-list",
  countEndpoint: "package/package-list-count",
  // P-11: Angular uses "package/delete-package" (not "package/package-delete")
  deleteEndpoint: "package/delete-package",
  // P-12: Angular uses "package/change-status" (not "package/package-status-change")
  statusEndpoint: "package/change-status",
  addPath: "/admin/packages/add",
  editPath: "/admin/packages/edit",
  addButtonLabel: "+ Add Package",
  columns: [
    // P-03: API returns "name" not "package_name"
    { key: "name", label: "Package Name", sortable: true },
    { key: "purchase_type", label: "Purchase Type" },
    { key: "package_type", label: "Package Type" },
    { key: "price", label: "Price", type: "currency", sortable: true },
    { key: "priority", label: "Priority", type: "number" },
    { key: "status", label: "Status", type: "status" },
    { key: "createdon_datetime", label: "Created At", type: "date", sortable: true },
  ],
  // P-14: Add search and filter fields
  searchFields: [
    { label: "Name", field: "name", placeholder: "Search by package name..." },
  ],
  filterFields: [
    {
      label: "Status",
      field: "status",
      values: [
        { val: "1", name: "Active" },
        { val: "0", name: "Inactive" },
      ],
    },
    {
      label: "Purchase Type",
      field: "purchase_type",
      values: [
        { val: "single", name: "Single" },
        { val: "multiple", name: "Multiple" },
        { val: "subscription", name: "Subscription" },
      ],
    },
  ],
  // PM-01: Created-date range filter
  dateRangeFields: [
    { label: "Created Date", field: "createdon_datetime" },
  ],
  // PM-01: Row preview from list data
  previewFromRow: true,
  previewFields: [
    { key: "name", label: "Package Name" },
    { key: "purchase_type", label: "Purchase Type" },
    { key: "subscription_period", label: "Subscription Period" },
    { key: "package_type", label: "Package Type" },
    { key: "sessions", label: "Sessions" },
    { key: "added_by_name", label: "Added By" },
    { key: "price", label: "Price", type: "currency" },
    { key: "description", label: "Description", type: "html" },
    { key: "priority", label: "Priority" },
    { key: "status", label: "Status", type: "badge" },
  ],
};

export default function PackagesPage() {
  return <GenericListPage config={config} />;
}
